import { ReactNode } from 'react';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { localize } from 'utils/numberHelpers';
import { Name } from './Name';

export const NAME_CELL_TEST_ID = 'name-cell';
export const METRIC_CELL_TEST_ID = 'metric-cell';

const NameCell = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

type MetricCellProps = {
  isBold: boolean;
};

const MetricCell = styled.div<MetricCellProps>`
  display: flex;
  font-weight: ${({ isBold }) => (isBold ? 700 : 'normal')};
  justify-content: flex-end;
  padding-right: ${spacing.threeQuarter};
`;

type CellProps = {
  value: ReactNode;
  trigger?: ReactNode;
  isIndented?: boolean;
  redirect?: boolean;
  snippetId?: number;
  isActive?: boolean;
};

export const Cell = ({ trigger, value, isIndented, snippetId, isActive, redirect }: CellProps) => {
  if (trigger || isIndented) {
    return (
      <NameCell data-test={NAME_CELL_TEST_ID}>
        <div onClick={(e) => e.stopPropagation()} className={isIndented ? 'indent' : ''}>
          <Name value={value} snippetId={snippetId} redirect={redirect} />
        </div>
        {trigger && trigger}
      </NameCell>
    );
  }

  const isBold = !!(isActive && snippetId);
  return (
    <MetricCell data-test={METRIC_CELL_TEST_ID} isBold={isBold}>
      {localize(value as number)}
    </MetricCell>
  );
};
